import React, {useState, useEffect} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import DatePicker from "react-datepicker";
import {
    calculateDaysDifference,
    CompanyPermission,
    formatDateTimeToString,
    formatDateToAmericanFormat,
    formatDateStringToString,
    renderSaleOptions,
    SaleStatus,
    statusOptions,
    statusTranslate,
    UserPermission,
    removeTimeFromDate, parseLocalDate
} from "../../utils/utils";
import {
    companyHasPermission,
    downloadSaleFile,
    findSectorsByQueryString,
    getSaleById,
    updateSaleStatus
} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {getAuthHeader} from "../../utils/auth";
import {useNavigate} from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import ModalDiv from "../../ModalDiv";
import {useReactToPrint} from "react-to-print";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import SaleViewer from "../sale/SaleViewer";
import AutomotiveServiceViewer from "../automotiveService/AutomotiveServiceViewer";
import ListPageLayout from '../common/ListPageLayout';
import Loading from "../../core/Loading";
import {loadingAtom} from "../../atoms";
import loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";
import PaymentMethodValueSelect from "../paymentMehod/PaymentMethodValueSelect";
import {getReceivableById} from "../../utils/requestUtils";
import {formatLocalDate} from "../../utils/utils";
import {saveAs} from 'file-saver';
import NewButton from '../common/NewButton';
import SearchButton from '../common/SearchButton';
import TableRowActions from '../common/TableRowActions';
import WhatsAppButton from '../../core/WhatsAppButton';
import {buildDefaultWhatsAppMessage} from '../../utils/whatsappUtils';

const apiUrl = Config.apiUrl;
const ReceivableList = (props) => {
    const { hasUserPermission, loadingPermissions, hasCompanyPermission } = usePermission();
    const [receivables, setReceivables] = useState([]);
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [status, setStatus] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalValue, setTotalValue] = useState(0);
    const navigate = useNavigate();
    const [saleIdToBeShowed, setSaleIdToBeShowed] = useState(undefined);
    const [automotiveServiceIdToBeShowed, setAutomotiveServiceIdToBeShowed] = useState(undefined);
    const [receivableToBeShowedInPaymentMethodValueSelect, setReceivableToBeShowedInPaymentMethodValueSelect] = useState(undefined);

    const [loading, setLoading] = useRecoilState(loadingAtom);

    // Função para obter o tipo de serviço e ID do backend usando o ID do receivable
    const getServiceTypeAndIdByReceivableId = async (receivableId) => {
        try {
            const url = `${apiUrl}/api/receivables/${receivableId}/service`;
            const response = await makeRequest(url, 'GET');
            return response;
        } catch (error) {
            console.error('Error fetching service type:', error);
            return null;
        }
    };

    const openServiceViewer = async (receivable) => {
        const serviceData = await getServiceTypeAndIdByReceivableId(receivable.id);
        if (!serviceData) {
            alert('Serviço não encontrado.');
            return;
        }

        if (serviceData.type === 'automotive') {
            setAutomotiveServiceIdToBeShowed(serviceData.id);
        } else {
            setSaleIdToBeShowed(serviceData.id);
        }
    };

    async function makeQuery() {
        try {
            setLoading(true);
            const newStartDate = startDate ? startDate : new Date(1900, 0, 1);
            const newEndDate = endDate ? endDate : new Date(2100, 0, 1);
            const url = `${apiUrl}/api/receivables/queryByDueDate?startDate=${formatDateToAmericanFormat(newStartDate)}&endDate=${formatDateToAmericanFormat(newEndDate)}&status=${status}&searchTerm=${searchTerm}`;
            const response = await makeRequest(url, 'GET');
            const updatedResponse = response.map(receivable => ({
                ...receivable,
                customerName: receivable.customerName ? receivable.customerName.toUpperCase() :  receivable?.customerCompany?.name?.toUpperCase(),
            }));
            setReceivables(updatedResponse);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    useEffect(() => {
        setTotalValue(receivables.reduce((acc, obj) => acc + obj.value, 0));
    }, [receivables]);

    async function removeReceivable(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/receivables/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery();
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleQuery = async (e) => {
        await makeQuery();
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };
    const onPayClick = async (id) => {
        const receivable = await getReceivableById(id);
        if (!window.confirm(`Deseja realmente ${!receivable.paymentDate ? "Baixar" : "Estornar"}?`)) {
            return;
        }
        if (receivable.paymentDate) {
            receivable.paymentDate = undefined;
            receivable.status = 0;
        } else {
            receivable.paymentDate = formatLocalDate(new Date());
            receivable.status = 1;
        }

        const url = apiUrl + '/api/receivables';
        setLoading(true);
        await makeRequest(url, 'PUT', {
            'Content-Type': 'application/json',
        }, JSON.stringify(receivable));
        setLoading(false);

        await makeQuery();
    };

    const handleReceivablePayAction = async (receivable) => {
        if (receivable.status === 1 && receivable.paymentDate || !hasCompanyPermission(CompanyPermission.SHOW_PAYMENT_METHOD_IN_RECEIVABLE_LIST_WHEN_CONFIRMING_RECEIVABLE)) {
            await onPayClick(receivable.id);
        } else {
            setReceivableToBeShowedInPaymentMethodValueSelect(receivable);
        }
    };

    const buildReceivableRowActions = (receivable) => {
        const actions = [];

        if (receivable?.customerPhone) {
            actions.push({
                key: 'whatsapp',
                label: 'WhatsApp',
                phoneNumber: receivable.customerPhone,
                personName: receivable.customerDisplayName,
                message: buildDefaultWhatsAppMessage(receivable.customerDisplayName),
                render: () => (
                    <WhatsAppButton
                        phoneNumber={receivable.customerPhone}
                        personName={receivable.customerDisplayName}
                    />
                ),
            });
        }

        if (receivable?.salesIds?.length > 0) {
            actions.push({
                key: 'service',
                label: 'Ver Serviço',
                onClick: () => openServiceViewer(receivable),
                render: () => (
                    <button
                        type="button"
                        disabled={receivable?.salesIds?.length === 0}
                        title={receivable?.salesIds?.length === 0 ? 'Nenhum servico para mostrar.' : ''}
                        onClick={() => openServiceViewer(receivable)}
                    >
                        Ver Serviço
                    </button>
                ),
            });
        }

        if (!receivable.paymentDate) {
            actions.push({
                key: 'pay',
                label: 'Baixar',
                type: 'confirm',
                onClick: () => handleReceivablePayAction(receivable),
                buttonProps: {
                    className: 'finish-button',
                    'data-test': 'receivable-finish-button',
                    title: 'Baixar',
                },
            });
        }

        if (receivable.paymentDate && hasUserPermission(UserPermission.REVERSE_RECEIVABLE)) {
            actions.push({
                key: 'reverse',
                label: 'Estornar',
                type: 'reverse',
                onClick: () => handleReceivablePayAction(receivable),
                buttonProps: {
                    'data-test': 'receivable-finish-button',
                    title: 'Estornar',
                },
            });
        }

        if (hasUserPermission(UserPermission.ENABLE_MERCADO_PAGO) && !receivable.paymentDate) {
            actions.push({
                key: 'mercadopago',
                label: 'Mercado Pago',
                onClick: () => handleMercadoPagoUrlCopy(receivable.id),
                render: () => (
                    <button
                        type="button"
                        className={receivable.preferenceIdMercadoPago ? 'mercado-pago-with-link-created-button' : 'mercado-pago-create-link-button'}
                        onClick={() => handleMercadoPagoUrlCopy(receivable.id)}
                        title={receivable.preferenceIdMercadoPago
                            ? 'Copiar link Mercado Pago gerado anteriormente'
                            : 'Gerar link Mercado Pago e copiar'}
                    >
                        Mercado Pago
                    </button>
                ),
            });
        }

        if (hasUserPermission(UserPermission.EDIT_RECEIVABLE)) {
            actions.push({
                key: 'edit',
                label: 'Editar',
                type: 'edit',
                onClick: () => navigate('/app/receivable?id=' + receivable.id),
            });
        }

        if (hasUserPermission(UserPermission.REMOVE_RECEIVABLE)) {
            actions.push({
                key: 'delete',
                label: 'Excluir',
                type: 'delete',
                onClick: async () => {
                    if (window.confirm('Deseja realmente excluir?')) {
                        await removeReceivable(receivable.id);
                    }
                },
            });
        }

        return actions;
    };

    function getBackgroundColor(receivable) {
        const currentDate = removeTimeFromDate(new Date());
        const dueDate = parseLocalDate(receivable.dueDate);
        const errorColor = 'var(--error-color)';
        const warningColor = 'var(--warning-color)';
        if (receivable.status === 0) {
            if (dueDate < currentDate)
                return errorColor;
            if (calculateDaysDifference(dueDate, currentDate) === 0) {
                return warningColor;
            }
        }
        return undefined;
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        setSearchTerm(string);
    };

    const generateExcelFile = async () => {
        try {
            const newStartDate = startDate ? startDate : new Date(1900, 0, 1);
            const newEndDate = endDate ? endDate : new Date(2100, 0, 1);
            const url = `${apiUrl}/api/receivables/excelByDueDate?startDate=${formatDateToAmericanFormat(newStartDate)}&endDate=${formatDateToAmericanFormat(newEndDate)}&status=${status}&searchTerm=${searchTerm}`;

            const response = await fetch(url, {headers: {...getAuthHeader()}});
            if (response.ok) {
                const data = await response.blob();
                saveAs(data, `relatorio-recebimentos-${formatDateToAmericanFormat(newStartDate)}-${formatDateToAmericanFormat(newEndDate)}.xlsx`);
            } else {
                console.error('Erro ao gerar o arquivo Excel:', response.statusText);
            }
        } catch (error) {
            console.error('Erro ao fazer a solicitação para gerar o arquivo Excel:', error);
        }
    };

    const [sortConfig, setSortConfig] = useState({key: 'dueDate', direction: 'ascending'});

    const [sortedSales, setSortedSales] = useState([]);

    useEffect(() => {
        setSortedSales([...receivables].sort((a, b) => {
            const aValue = sortConfig.key.includes('.')
                ? (a[sortConfig.key.split('.')[0]]?.[sortConfig.key.split('.')[1]] ?? '')
                : (a[sortConfig.key] ?? '');
            const bValue = sortConfig.key.includes('.')
                ? (b[sortConfig.key.split('.')[0]]?.[sortConfig.key.split('.')[1]] ?? '')
                : (b[sortConfig.key] ?? '');

            if (aValue < bValue) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        }));
    }, [receivables, sortConfig]);

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({key, direction});
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '▲' : '▼';
        }
        return '';
    };

    // Mercado Pago URL generation and clipboard copy
    async function handleMercadoPagoUrlCopy(receivableId) {
        const url = `${apiUrl}/api/mercadopago/create-preference/${receivableId}`;
        try {
            setLoading(true);
            const response = await makeRequest(url, 'POST');
            const preferenceId = response.preferenceId;
            const mercadoPagoUrl = `https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=${preferenceId}`;
            await navigator.clipboard.writeText(mercadoPagoUrl);
            alert('Link Mercado Pago copiado para a área de transferência.');
            makeQuery();
        } catch (error) {
            alert('Erro ao gerar/copiar link Mercado Pago.');
            console.error('Erro ao criar preferência de pagamento:', error);
        } finally {
            setLoading(false);
        }
    }

    if (loadingPermissions) {
        return <Loading/>;
    }

    if (hasUserPermission(UserPermission.LIST_RECEIVABLE) === false) {
        navigate('/unauthorizedaccess');
    }

    return (
        <>
            {receivableToBeShowedInPaymentMethodValueSelect && (
                <PaymentMethodValueSelect onClose={() => setReceivableToBeShowedInPaymentMethodValueSelect(undefined)}
                                          allowChangeValue={false}
                                          allowChangeDueDate={false}
                                          forceDueDate={new Date()}
                                          paymentMethods={[{
                                              paymentMethod: receivableToBeShowedInPaymentMethodValueSelect.paymentMethod,
                                              value: receivableToBeShowedInPaymentMethodValueSelect.value,
                                              paid: receivableToBeShowedInPaymentMethodValueSelect.status === 1,
                                              splits: receivableToBeShowedInPaymentMethodValueSelect.receivableSplits ? receivableToBeShowedInPaymentMethodValueSelect.receivableSplits.length : 1,
                                              dueDate: receivableToBeShowedInPaymentMethodValueSelect.dueDate,
                                          }]}
                                          totalValue={receivableToBeShowedInPaymentMethodValueSelect.value}
                                          onConfirm={async (paymentMethodValues) => {
                                              if (!paymentMethodValues || paymentMethodValues.length === 0) {
                                                  return;
                                              }
                                              const paymentMethodValue = paymentMethodValues[0];
                                              if (!paymentMethodValue.paymentMethod) {
                                                   alert("Informe uma forma de pagamento.");
                                                   return;
                                               }
                                              setReceivableToBeShowedInPaymentMethodValueSelect(undefined)
                                              const receivable = await getReceivableById(receivableToBeShowedInPaymentMethodValueSelect.id);
                                              receivable.paymentMethod = paymentMethodValue.paymentMethod;
                                              receivable.value = paymentMethodValue.value;
                                              receivable.paid = true;
                                              receivable.status = 1;
                                              receivable.paymentDate = new Date().toISOString().split('T')[0];
                                              setLoading(true);
                                              const url = apiUrl + '/api/receivables';
                                              await makeRequest(url, 'PUT', {
                                                  'Content-Type': 'application/json',
                                              }, JSON.stringify(receivable));
                                              if (receivableToBeShowedInPaymentMethodValueSelect.splits !== paymentMethodValue.splits) {
                                                  const url = apiUrl + '/api/receivables/' + receivable.id + '/updatesplits/' + paymentMethodValue.splits;
                                                  await makeRequest(url, 'PUT', {
                                                      'Content-Type': 'application/json',
                                                  }, JSON.stringify(receivable));
                                              }
                                              setLoading(false);
                                              await makeQuery();
                                          }}/>)}

            {saleIdToBeShowed && <ModalDiv closeModal={() => setSaleIdToBeShowed(undefined)}>
                <SaleViewer saleId={saleIdToBeShowed}>
                </SaleViewer>
            </ModalDiv>}

            {automotiveServiceIdToBeShowed && <ModalDiv closeModal={() => setAutomotiveServiceIdToBeShowed(undefined)}>
                <AutomotiveServiceViewer 
                    serviceId={automotiveServiceIdToBeShowed}
                    onClose={() => setAutomotiveServiceIdToBeShowed(undefined)}
                />
            </ModalDiv>}
            <ListPageLayout
                tableWidth={1100}
                header={
                    <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                        <div className="header-label">Consulta de Recebimentos</div>
                        {hasUserPermission(UserPermission.CREATE_RECEIVABLE) &&
                            <NewButton className={"new-button"} onClick={() => navigate('/app/receivable')}/>
                        }
                    </div>
                }
                filters={
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%'}}>
                <div style={{display: 'flex'}}>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        {`Nome/Descrição${hasUserPermission(UserPermission.LIST_SERVICE) ? '/Serviço' : ''}:`}
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input type="text" value={searchTerm} onChange={handleInputChange} data-test={"search-input"}/>
                        </div>
                    </div>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        Data de Vencimento:
                        <div className="list-page-filters-period" style={{display: 'flex', alignItems: 'center'}}>
                            <DatePicker
                                className="datepicker"
                                selected={startDate}
                                onChange={handleStartDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />

                            até
                            <DatePicker
                                className="datepicker"
                                selected={endDate}
                                onChange={handleEndDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />


                            <select value={status} onChange={(e) => setStatus(parseInt(e.target.value))}
                                    data-test={"receivable-status-select"}>
                                <option key={-1} value={-1}>Todos</option>
                                <option key={0} value={0}>Pendente</option>
                                <option key={1} value={1}>Pago</option>
                            </select>
                            <SearchButton title="Consultar" onClick={handleQuery} data-test={"receivable-search-button"}/>


                        </div>

                    </div>

                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <button className="excel-button" onClick={generateExcelFile}>Excel</button>
                </div>
            </div>
                }
                footer={hasUserPermission(UserPermission.SHOW_TOTAL_RECEIVABLE_LIST) ? (
                    <div className="total-label">Valor Total: R$ {totalValue.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}</div>
                ) : null}
            >
            <div className="list-page-receivables">
            <table>
                <thead>
                <tr>
                    <th className="receivable-col--essential" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('customerName')}>
                        {getSortIcon('customerName')} Cliente
                    </th>
                    <th className="receivable-col--optional" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('description')}>
                        {getSortIcon('description')} Descrição
                    </th>
                    <th className="receivable-col--optional" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('paymentMethod.name')}>
                        {getSortIcon('paymentMethod.name')} Forma de Pagamento
                    </th>
                    <th className="receivable-col--optional" style={{cursor: "pointer", minWidth: "100px", textAlign: 'center'}} onClick={() => handleSort('date')}>
                        {getSortIcon('date')} Lançamento
                    </th>
                    <th className="receivable-col--essential" style={{cursor: "pointer", minWidth: "100px", textAlign: 'center'}} onClick={() => handleSort('dueDate')}>
                        {getSortIcon('dueDate')} Vencimento
                    </th>
                    <th className="receivable-col--optional" style={{cursor: "pointer", minWidth: "100px", textAlign: 'center'}} onClick={() => handleSort('paymentDate')}>
                        {getSortIcon('paymentDate')} Pagamento
                    </th>
                    <th className="receivable-col--essential" style={{cursor: "pointer", minWidth: "100px", textAlign: 'right'}} onClick={() => handleSort('value')}>
                        {getSortIcon('value')} Valor
                    </th>
                    <th className="receivable-col--actions"/>
                </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                {sortedSales.map((receivable, index) => (


                    <tr key={receivable.id} style={{backgroundColor: getBackgroundColor(receivable)}}>
                        <td className="receivable-col--essential">
                            <div>{receivable?.customerDisplayName}</div>
                            {receivable.description && <div className="receivable-description--mobile">{receivable.description}</div>}
                        </td>
                        <td className="receivable-col--optional">
                            <div>{receivable.description}</div>
                        </td>
                        <td className="receivable-col--optional">
                            <div>{receivable.paymentMethod?.name || ''}</div>
                        </td>
                        <td className="receivable-col--optional">
                            <div style={{textAlign: 'center'}}>{formatDateTimeToString(new Date(receivable.date))}</div>
                        </td>
                        <td className="receivable-col--essential">
                            <div style={{textAlign: 'center'}}>{formatDateStringToString(receivable.dueDate)}</div>
                        </td>
                        <td className="receivable-col--optional">
                            <div style={{textAlign: 'center'}}>{receivable.paymentDate ? formatDateStringToString(receivable.paymentDate) : "Pendente"}</div>
                        </td>
                        <td className="receivable-col--essential">
                            <div style={{textAlign: 'right'}}>R$ {receivable.value.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</div>
                        </td>
                        <td className="receivable-col--actions table-actions">
                            <TableRowActions actions={buildReceivableRowActions(receivable)} />
                        </td>

                    </tr>
                ))}
                </tbody>
                {receivables.length === 0 && (<tfoot><tr><td colSpan={8}>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</td></tr></tfoot>)}
            </table>
            </div>
            </ListPageLayout>

        </>
    );
};

export default ReceivableList;
